import { Button } from '@/components/UI/Button'
import { Typography } from '@/components/UI/Typography'
import { useTranslation } from 'react-i18next'

type Props = {
  /** 再試行ボタン押下時のコールバック（next/dynamic の retry）。未指定ならボタンを出さない */
  onRetry?: () => void
}

/**
 * SpotMap（MapLibre）のチャンク読み込みに失敗したときに地図エリアに表示する案内。
 * スケルトンを出し続けて「読み込み中」と伝え続けないよう、失敗を明示して再試行の導線を出す。
 * SpotMapSkeleton と同じく親（main）の全面を覆う。
 */
export function SpotMapLoadFailed({ onRetry }: Props) {
  const { t } = useTranslation()

  return (
    <div
      data-testid="spot-map-load-failed"
      role="alert"
      className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-4 bg-white p-6 text-center"
    >
      <Typography variant="body2" c="#686868">
        {t('common.fetch_failed', 'データの取得に失敗しました')}
      </Typography>
      {onRetry && <Button label={t('common.retry', '再試行')} variant="primary" size="sm" onClick={onRetry} />}
    </div>
  )
}
